// extracted by mini-css-extract-plugin
export var box = "_3n-0";
export var check = "_3n-1";
export var checkboxButton = "_3n-6";
export var checkboxGroup = "_3n-5";
export var disabled = "_3n-7";
export var ghost = "_3n-9";
export var input = "_3n-2";
export var label = "_3n-4";
export var normal = "_3n-8";
export var uncheck = "_3n-3";